import {
  targetGroupsBySNConstants,
  createTargetGroupsBySNConstants,
  editTargetGroupsBySNConstants,
  addTargetGroupsBySNConstants,
  removeTargetGroupsBySNConstants,
  deleteTargetGroupsBySNConstants,
} from "../_redux-constants";
import { targetGroupsSNService } from "../../_services";
import { errorExtractor } from "../../_helpers";

function getTargetGroupsBySN(requestBody, queryParams) {
  function getTargetGroupsBySNLoad() {
    return { type: targetGroupsBySNConstants.TARGET_GROUPS_BY_SN_LOADING };
  }
  function getTargetGroupsBySNSuccess(data) {
    return {
      type: targetGroupsBySNConstants.TARGET_GROUPS_BY_SN_SUCCESS,
      data,
    };
  }
  function getTargetGroupsBySNFailure(error) {
    return {
      type: targetGroupsBySNConstants.TARGET_GROUPS_BY_SN_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(getTargetGroupsBySNLoad());
    return targetGroupsSNService
      .getTargetGroupsBySN(requestBody, queryParams)
      .then(
        (data) => {
          dispatch(getTargetGroupsBySNSuccess(data));
        },
        (error) => {
          dispatch(getTargetGroupsBySNFailure(error?.toString()));
        }
      );
  };
}

function createTargetGroupsBySN(requestBody) {
  function createTargetGroupsBySNLoad() {
    return {
      type: createTargetGroupsBySNConstants.CREATE_TARGET_GROUPS_BY_SN_LOADING,
    };
  }
  function createTargetGroupsBySNSuccess(data) {
    return {
      type: createTargetGroupsBySNConstants.CREATE_TARGET_GROUPS_BY_SN_SUCCESS,
      data,
    };
  }
  function createTargetGroupsBySNFailure(error) {
    return {
      type: createTargetGroupsBySNConstants.CREATE_TARGET_GROUPS_BY_SN_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(createTargetGroupsBySNLoad());
    return new Promise((resolve, reject) => {
      targetGroupsSNService.createTargetGroupsBySN(requestBody).then(
        (data) => {
          dispatch(createTargetGroupsBySNSuccess(data));
          resolve(data);
        },
        (error) => {
          dispatch(createTargetGroupsBySNFailure(error?.toString()));
          errorExtractor(error, reject);
        }
      );
    });
  };
}

function editTargetGroupsBySN(requestBody, queryParams) {
  function editTargetGroupsBySNLoad() {
    return {
      type: editTargetGroupsBySNConstants.EDIT_TARGET_GROUPS_BY_SN_LOADING,
    };
  }
  function editTargetGroupsBySNSuccess(data) {
    return {
      type: editTargetGroupsBySNConstants.EDIT_TARGET_GROUPS_BY_SN_SUCCESS,
      data,
    };
  }
  function editTargetGroupsBySNFailure(error) {
    return {
      type: editTargetGroupsBySNConstants.EDIT_TARGET_GROUPS_BY_SN_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(editTargetGroupsBySNLoad());
    return new Promise((resolve, reject) => {
      targetGroupsSNService.editTargetGroupsBySN(requestBody, queryParams).then(
        (data) => {
          dispatch(editTargetGroupsBySNSuccess(data));
          resolve(data);
        },
        (error) => {
          dispatch(editTargetGroupsBySNFailure(error?.toString()));
          errorExtractor(error, reject);
        }
      );
    });
  };
}

function addTargetGroupsBySN(requestBody, queryParams) {
  function addTargetGroupsBySNLoad() {
    return {
      type: addTargetGroupsBySNConstants.ADD_TARGET_GROUPS_BY_SN_LOADING,
    };
  }
  function addTargetGroupsBySNSuccess(data) {
    return {
      type: addTargetGroupsBySNConstants.ADD_TARGET_GROUPS_BY_SN_SUCCESS,
      data,
    };
  }
  function addTargetGroupsBySNFailure(error) {
    return {
      type: addTargetGroupsBySNConstants.ADD_TARGET_GROUPS_BY_SN_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(addTargetGroupsBySNLoad());
    return new Promise((resolve, reject) => {
      targetGroupsSNService.addTargetGroupsBySN(requestBody, queryParams).then(
        (data) => {
          dispatch(addTargetGroupsBySNSuccess(data));
          resolve(data);
        },
        (error) => {
          dispatch(addTargetGroupsBySNFailure(error?.toString()));
          errorExtractor(error, reject);
        }
      );
    });
  };
}

function removeTargetGroupsBySN(queryParams) {
  function removeTargetGroupsBySNLoad() {
    return {
      type: removeTargetGroupsBySNConstants.REMOVE_TARGET_GROUPS_BY_SN_LOADING,
    };
  }
  function removeTargetGroupsBySNSuccess(data) {
    return {
      type: removeTargetGroupsBySNConstants.REMOVE_TARGET_GROUPS_BY_SN_SUCCESS,
      data,
    };
  }
  function removeTargetGroupsBySNFailure(error) {
    return {
      type: removeTargetGroupsBySNConstants.REMOVE_TARGET_GROUPS_BY_SN_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(removeTargetGroupsBySNLoad());
    return new Promise((resolve, reject) => {
      targetGroupsSNService.removeTargetGroupsBySN(queryParams).then(
        (data) => {
          dispatch(removeTargetGroupsBySNSuccess(data));
          resolve(data);
        },
        (error) => {
          dispatch(removeTargetGroupsBySNFailure(error?.toString()));
          errorExtractor(error, reject);
        }
      );
    });
  };
}

function deleteTargetGroupsBySN(queryParams) {
  function deleteTargetGroupsBySNLoad() {
    return {
      type: deleteTargetGroupsBySNConstants.DELETE_TARGET_GROUPS_BY_SN_LOADING,
    };
  }
  function deleteTargetGroupsBySNSuccess(data) {
    return {
      type: deleteTargetGroupsBySNConstants.DELETE_TARGET_GROUPS_BY_SN_SUCCESS,
      data,
    };
  }
  function deleteTargetGroupsBySNFailure(error) {
    return {
      type: deleteTargetGroupsBySNConstants.DELETE_TARGET_GROUPS_BY_SN_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(deleteTargetGroupsBySNLoad());
    return new Promise((resolve, reject) => {
      targetGroupsSNService.deleteTargetGroupsBySN(queryParams).then(
        (data) => {
          dispatch(deleteTargetGroupsBySNSuccess(data));
          resolve(data);
        },
        (error) => {
          dispatch(deleteTargetGroupsBySNFailure(error?.toString()));
          errorExtractor(error, reject);
        }
      );
    });
  };
}

export const targetGroupsBySNActions = {
  getTargetGroupsBySN,
  createTargetGroupsBySN,
  editTargetGroupsBySN,
  addTargetGroupsBySN,
  removeTargetGroupsBySN,
  deleteTargetGroupsBySN,
};
